import {FanModerator} from '@shared/models/fanmoderator';
import {Picture, PictureSize} from '@core/services/picture';
import {AppTeam} from '@shared/models/team';
import {TeamModerator} from '@shared/models/teamModerator';
import {ISponsor} from '@api/models/sponsor/sponsor';
import { IEventTeam } from '@api/models/event/event-team';

export class MatchTeam {
  teamid: string;
  name: string;
  abbreviation: string;
  readable_id: string;
  formation: number;
  score: number;
  sponsors: ISponsor[];
  moderators: TeamModerator[];
  fan_moderator: FanModerator;
  moderation_type: string;
  pictures: Picture[];
  live_lineup: {
    lineup: string[];
    reserve: string[];
    replaced: string[];
  };
  hasTeamModerator: boolean = false;

  public constructor(init?: Partial<IEventTeam>) {
    Object.assign(this, init);
    this.hasTeamModerator = TeamModerator.hasTeamModerator(this.moderators);
    this.pictures = this.pictures?.map(picture => new Picture(picture)) || [];
    this.moderators = init.moderators || [];
    this.fan_moderator = new FanModerator(init.fan_moderator);
  }

  getLogoImageUrl(size: PictureSize): string {
    return AppTeam.getLogoImageUrl(this.pictures, size);
  }
}
